// Package Imports
import PageSkeleton from '@/core/components/page-skeleton'
import RouteError from '@/core/components/route-error'
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

// Core Imports
import { queryClient } from '@/core/lib/query-client'
import { routeHasPermission } from '@/core/utils/auth-utils'

// External Module Imports
import { dashboardRoute } from '@/modules/dashboard/dashboard.routes'

// Module Imports
import {
  tournamentDetailQueryOptions,
  tournamentListQueryOptions,
} from '@/modules/tournament/tournament.hooks'

export const tournamentRoute = createRoute({
  path: '/tournaments',
  getParentRoute: () => dashboardRoute,
  errorComponent: ({ error, reset }) => (
    <RouteError error={error} reset={reset} />
  ),
})

export const tournamentListRoute = createRoute({
  getParentRoute: () => tournamentRoute,
  path: '/',
  beforeLoad: async ({ preload }) =>
    routeHasPermission(
      preload,
      'tournaments.list',
      'Turnuva listesine erişim izniniz yok.'
    ),
  head: () => ({ meta: [{ title: 'Turnuvalar' }] }),
  loader: async () => {
    await queryClient.ensureQueryData(
      tournamentListQueryOptions({ page: 1, perPage: 10 })
    )
  },
  pendingComponent: () => <PageSkeleton />,
  pendingMs: 100,
  component: lazyRouteComponent(
    () => import('@/modules/tournament/pages/list-tournament.page')
  ),
})

export const tournamentCreateRoute = createRoute({
  getParentRoute: () => tournamentRoute,
  path: '/create',
  beforeLoad: async ({ preload }) =>
    routeHasPermission(
      preload,
      'tournaments.create',
      'Turnuva oluşturma izniniz yok.'
    ),
  head: () => ({ meta: [{ title: 'Yeni Turnuva' }] }),
  component: lazyRouteComponent(
    () => import('@/modules/tournament/pages/create-tournament.page')
  ),
})

export const tournamentDetailRoute = createRoute({
  getParentRoute: () => tournamentRoute,
  path: '/$id',
  beforeLoad: async ({ preload }) =>
    routeHasPermission(
      preload,
      'tournaments.detail',
      'Turnuva detayına erişim izniniz yok.'
    ),
  head: () => ({ meta: [{ title: 'Turnuva Detayı' }] }),
  loader: async ({ params: { id } }) => {
    await queryClient.ensureQueryData(tournamentDetailQueryOptions(id))
  },
  component: lazyRouteComponent(
    () => import('@/modules/tournament/pages/tournament-detail.page')
  ),
})

export const tournamentEditRoute = createRoute({
  getParentRoute: () => tournamentRoute,
  path: '/$id/edit',
  beforeLoad: async ({ preload }) =>
    routeHasPermission(
      preload,
      'tournaments.edit',
      'Turnuva düzenleme izniniz yok.'
    ),
  head: () => ({ meta: [{ title: 'Turnuva Düzenle' }] }),
  loader: async ({ params: { id } }) => {
    await queryClient.ensureQueryData(tournamentDetailQueryOptions(id))
  },
  component: lazyRouteComponent(
    () => import('@/modules/tournament/pages/edit-tournament.page')
  ),
})
